import * as React from 'react';

import CloudinaryImage from 'components/CloudinaryImage';
import ConsentPlaceholder from 'components/consent-placeholder/ConsentPlaceholder';

import { CHANNEL_TYPE_INSTAGRAM } from 'utils/channels';
import { isInstagramUrl } from 'utils/url';

import './inspirational-materials-grid-item.scss';

import type { ImageStandard } from 'types';
import type { ConsentReducerConsentsMap } from 'redux-store/types/ConsentReducer.type';

type Props = {
  asset: ImageStandard,
  userChannelConsents: ConsentReducerConsentsMap,
  withCloudinary?: boolean,
  onSelect: (a: ImageStandard) => void
};

// Cloudinary image size same as on content page in order to reuse cached images
const InspirationalMaterialsGridItem = (
  {
    asset,
    userChannelConsents,
    withCloudinary,
    onSelect
  }: Props
): JSX.Element => {
  let child: JSX.Element | null = null;

  if (withCloudinary) {
    child = (
      <CloudinaryImage
        className="inspirational-materials-grid-item__image"
        image={{ url: asset.assetUrl }}
        width={188}
        height={188}
      />
    );
  } else if (isInstagramUrl(asset.url) && !userChannelConsents[CHANNEL_TYPE_INSTAGRAM]) {
    child = (
      <ConsentPlaceholder
        withLearnMore
        type="instagram"
        link={asset.url}
      />
    );
  } else {
    child = (
      <img
        data-src={asset.assetUrl}
        alt=""
        className="inspirational-materials-grid-item__image lazyload"
      />
    );
  }

  return (
    <div
      className="inspirational-materials-grid-item"
      onClick={() => onSelect(asset)}
    >
      {child}
    </div>
  );
};

export default InspirationalMaterialsGridItem;
